// Module
var code = "<span *ngIf=\"count\" class=\"float-right badge badge-danger\">{{count}}</span>";
// Exports
module.exports = code;